import React, { useEffect, useState } from "react";
import { Card, CardContent, Typography } from "@material-ui/core";
import BarChart from "../../shared/components/charts/BarChart";
import LineChart from "../../shared/components/charts/LineChart";
import ApiService from "../../service/ApiService";
import cardStyles from "../styles/cardStyles";
import useStyles from "./styles";
import { Skeleton } from "@mui/material";
import { Spinner } from "../../components";
import AlertService from "../../service/AlertService";
import ToastMessages from "../../model/enum/ToastMessages";
import { ToastContainer } from "react-toastify";
import StatsResponse from "../../model/statsResponse";

const Labels = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const Stats = () => {
  const classes = useStyles();
  const styles = cardStyles();
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [year, setYear] = useState(new Date().getFullYear());
  const yearList = [2025, 2024, 2023];
  const [graphType, setGraphType] = useState("Bar");
  const graphTypes = ["Bar", "Line"];

  // Fetch all
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const [appointmentsData, requestsData, contactsData] =
          await Promise.all([
            ApiService.get<StatsResponse[]>(`stats/appointments?year=${year}`),
            ApiService.get<StatsResponse[]>(`stats/requests?year=${year}`),
            ApiService.get<StatsResponse[]>(`stats/messages?year=${year}`),
          ]);
        setData({
          labels: Labels,
          datasets: [
            {
              label: "Appointments",
              data: appointmentsData.flat().map((data: any) => data.count), //returns a single array of all the counts
              backgroundColor: "rgba(24, 47, 88, 1)",
            },
            {
              label: "Messages",
              data: requestsData.flat().map((data: any) => data.count),
              backgroundColor: "rgba(36, 71, 133, 1)",
            },
            {
              label: "Requests",
              data: contactsData.flat().map((data: any) => data.count),
              backgroundColor: "rgba(56, 110, 207, 1)",
            },
          ],
        });
      } catch (error) {
        AlertService.error(ToastMessages.FETCH_FAILED);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [year]);

  const handleYearChange = (e: any) => {
    setLoading(true);
    setData({});
    setYear((_year) => parseInt(e.target.value));
  };

  const handleTypeChange = (e: any) => setGraphType(e.target.value);

  const Graph = () => {
    if (Object.keys(data).length === 0) {
      return <Typography>No data available for the selected year.</Typography>;
    }

    switch (graphType) {
      case "Bar":
        return <BarChart chartData={data} />;
      case "Line":
        return <LineChart chartData={data} />;
    }

    return <></>;
  };

  return (
    <>
      <Card raised className={styles.card}>
        {loading ? (
          <>
            <Spinner />
            <Skeleton style={{ height: "30rem" }} />
          </>
        ) : (
          <>
            <div className={styles.headerContainer}>
              <Typography className={styles.title}>Statistics</Typography>
              <div>
                <select
                  value={graphType}
                  className={classes.selector}
                  onChange={handleTypeChange}
                >
                  {graphTypes.map((graph: string) => (
                    <option>{graph}</option>
                  ))}
                </select>{" "}
                <select
                  className={classes.selector}
                  onChange={handleYearChange}
                  value={year}
                >
                  {yearList.map((y: number) => (
                    <option>{y}</option>
                  ))}
                </select>
              </div>
            </div>
            <CardContent className={classes.statsCardContent}>
              <Graph />
            </CardContent>
          </>
        )}
      </Card>
      <ToastContainer />
    </>
  );
};

export default Stats;
